export default __webpack_public_path__ + "static/media/mr.59b9f4df.svg";